var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detailed-list-store"},[_vm._m(0),_c('div',{staticClass:"detailed-list-store-content"},[_c('store-wares')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detailed-list-store-title"},[_c('span',[_vm._v("保罗标物旗舰店")])])
}]

export { render, staticRenderFns }